import { type RouteObject } from 'react-router';

import { RequirePermission } from '@saniplus/ui';

import { PermissionFallback } from '../../components/shared/PermissionFallback';
import { HeuresGate } from './components/HeuresGate';

/**
 * The `Heures` section: the ad hoc date-range hour query and the export
 * wizard. No payroll functionality (pay periods, approval, lock) as of
 * 2026-08-30 — removed, to be redesigned later.
 *
 * Every route is gated on `timesheet:read` — the permission the API itself
 * requires on both reads. The guard is not a security control (the server
 * answers 403/404 on its own); it exists so the UI never offers a door that is
 * already locked, and it renders an explanation rather than redirecting.
 *
 * `/heures/exports` carries a second gate, on the route rather than inside the
 * wizard, because the export is a *write* the nav already hides from anyone
 * without `timesheet:export` (`nav.ts`). Enforcing only `timesheet:read` there
 * would let a supervisor who was never offered the link walk the whole wizard
 * and be refused at the last button. It sits on the route, not in the page, so
 * `router.spec.ts` can see it: a guard the router honours but the inventory
 * cannot read is a guard nobody notices losing.
 *
 * Code-split per route (D-17 bundle rule): a supervisor who never opens the
 * export wizard never downloads it.
 */
export const routes: RouteObject[] = [
  {
    path: '/heures',
    Component: HeuresGate,
    children: [
      { index: true, lazy: adHoc },
      { path: 'feuilles', lazy: adHoc },
      {
        element: (
          <RequirePermission
            permission={['timesheet:read', 'timesheet:export']}
            fallback={<PermissionFallback />}
          />
        ),
        children: [{ path: 'exports', lazy: exportsRoute }],
      },
    ],
  },
];

async function adHoc() {
  return { Component: (await import('./pages/AdHocTimesheetsPage')).AdHocTimesheetsPage };
}

async function exportsRoute() {
  return { Component: (await import('./pages/ExportsPage')).ExportsPage };
}
